import { render, staticRenderFns } from "./WidgetTemplateForm.vue?vue&type=template&id=677670aa&scoped=true&"
import script from "./WidgetTemplateForm.vue?vue&type=script&lang=js&"
export * from "./WidgetTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTemplateForm.vue?vue&type=style&index=0&id=677670aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677670aa",
  null
  
)

export default component.exports